import React from "react"
import {Link, withPrefix} from 'gatsby';
import Layout from "../../components/layout";
import SEO from "../../components/seo"

class ProductItemPage extends React.Component {

  render() {
    const {subCat, data} = this.props.pageContext;
    const commonLink=`/catalog/cmo`;
    const parentCatLink = `${commonLink}${subCat.url}`;
    const pageTitle = `ЦМО: ${data.title}`;
    // console.log('ProductItemPage', this.props.pageContext);

    return <Layout>
        <SEO title={pageTitle} />
        <div id="main" className='catalog'>
            <div className="inner">
                <div className='parent-category'>
                    <Link to={parentCatLink}>&larr; {subCat.title}</Link>
                </div>
                <h1>{data.title}</h1>
                <section className='categories'>
                    <div className="row">
                        <div className="col-4">
                            <div className="image fit">
                                <img src={withPrefix(data.imgExtended[0])} alt={data.code} />
                            </div>
                            {data.imgExtended[1] && <div className="image fit">
                              <img src={withPrefix(data.imgExtended[1])} alt={data.code} />
                            </div>}
                            {data.imgExtended[2] && <div className="image fit">
                              <img src={withPrefix(data.imgExtended[2])} alt={data.code} />
                            </div>}
                        </div>
                        <div className="col-8">
                            {data.description && data.description.data && data.description.data[0] && <table>
                                <thead>
                                <tr>
                                    <th>{data.description.data[0][0]}</th>
                                    <th>{data.description.data[1][0]}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {data.description.data[0].filter((item, i) => i !== 0).map((item, i) => {
                                    const info = data.description.data[1][i];
                                    return <tr key={i}>
                                        <td>{item}</td>
                                        <td>{info}</td>
                                    </tr>
                                })}
                                </tbody>
                            </table>}

                        </div>
                        {data.description && data.description.text && <div className="col-12">
                          <div dangerouslySetInnerHTML={{ __html: data.description.text }} />
                        </div>}
                    </div>
                </section>
            </div>
        </div>
    </Layout>;
  }
}

export default ProductItemPage;
